module.exports = __webpack_public_path__ + "static/media/1012705.1c5c2073.jpg";